class IntegratorListCell extends UITableViewCell
{
    private nameLabel: MUILabel = null;
    private typeLabel: MUILabel = null;
    private statusLabel: MUILabel = null;

    awakeFromHTML() {
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.typeLabel = MUIOutlet(this, "type-lbl", "MUILabel");
        this.statusLabel = MUIOutlet(this, "status-lbl", "MUILabel");
    }

    private _item: Integrator = null;
    set item(item: Integrator) {
        this._item = item;
        this.nameLabel.text = item.name;
        this.typeLabel.text = item.type;
        this.setHealth(null);
    }

    // The list's status chip, from the bulk health call: worst problem first, so a
    // half-configured or halted integration is visible before anyone opens it.
    setHealth(health: any) {
        if (this.statusLabel == null) return;
        let text = health != null ? IntegratorHealthSummary.text(health) : "";
        this.statusLabel.text = text;
        let ready = text == MIOLocalizeString("READY", "READY");
        this.statusLabel.layer.classList.toggle("status-alert", text.length > 0 && !ready);
    }
}
